type Unit = 's' | 'm' | 'h' | 'd' | 'w';
export type Duration = `${number}${Unit}`;

function validateDuration(duration: string): asserts duration is Duration {
    const pattern = /^[0-9]+[s|m|h|d|w]$/;
    if (!pattern.test(duration)) {
        throw new Error(`Invalid duration: ${duration}`);
    }
}

/**
 * Parses a duration string into milliseconds.
 * Returns the number if it is already a number.
 * @example
 * parseDuration('1s') // 1000
 * parseDuration('1w') // 604800000
 * parseDuration(1000) // 1000
 */
export const parseDuration = (duration: Duration | number) => {
    if (typeof duration === 'number') {
        return duration;
    }
    validateDuration(duration);
    const units = {
        s: 1000,
        m: 60 * 1000,
        h: 60 * 60 * 1000,
        d: 24 * 60 * 60 * 1000,
        w: 7 * 24 * 60 * 60 * 1000,
    };
    const [count, unit] = duration.split(/([a-z])/) as [string, Unit];
    return parseInt(count, 10) * units[unit];
};
